import React from "react";
import accountIcon from "@iconify/icons-mdi/account";
import bagIcon from "@iconify/icons-mdi/bag-personal";
import clockIcon from "@iconify/icons-mdi/clock";
import cafeteriaIcon from "@iconify/icons-mdi/coffee";
import myNewsIcon from "@iconify/icons-mdi/newspaper-variant";
import textBoxMultiple from "@iconify/icons-mdi/text-box-multiple";
import mySheetIcon from "@iconify/icons-mdi/timer";
import { InlineIcon } from "@iconify/react";

export const getModuleIcon = (modul: string) => {
  switch (modul) {
    case "MyHR":
      return (
        <InlineIcon
          icon={accountIcon}
          height="28px"
          style={{ color: "#4D4D4D" }}
        />
      );
    case "MyLeave":
      return (
        <InlineIcon icon={bagIcon} height="28px" style={{ color: "#4D4D4D" }} />
      );
    case "MyCafeteria":
      return (
        <InlineIcon
          icon={cafeteriaIcon}
          height="28px"
          style={{ color: "#4D4D4D" }}
        />
      );
    case "MyTime":
      return (
        <InlineIcon
          icon={clockIcon}
          height="28px"
          style={{ color: "#4D4D4D" }}
        />
      );
    case "MyTimesheet":
      return (
        <InlineIcon
          icon={mySheetIcon}
          height="28px"
          style={{ color: "#4D4D4D" }}
        />
      );
    case "MyDocuments":
      return (
        <InlineIcon
          icon={textBoxMultiple}
          height="28px"
          style={{ color: "#4D4D4D" }}
        />
      );
    case "MyNews":
      return (
        <InlineIcon
          icon={myNewsIcon}
          height="28px"
          style={{ color: "#4D4D4D" }}
        />
      );
    default:
      return null;
  }
};

export default getModuleIcon;
